import React, { Component } from "react";
import { connect } from "react-redux";
import { FiThumbsUp } from "react-icons/fi";
import { Link } from "react-router-dom";
import { FormGroup, FormControl } from "react-bootstrap";
import * as groupsActions from "actions/groupsActions";
import Avatar from "components/Avatar";
import { timesService, authService } from "services";
import { TIME_ALERTS } from "components/Times/utils";
import { convertFromUTC } from "utils/datetime";
import { withTranslation } from "react-i18next";

class Dashboard_TimeAlerts extends Component {
	constructor(props) {
		super(props);
		this.state = {
			alerts: [],
			filtered_alerts: [],
		};
	}

	componentDidMount() {
		this.getAlerts();
		this.getGroups();
	}

	async getAlerts() {
		try {
			// Verificar que el token esté disponible antes de hacer la petición
			if (!authService.token || !authService.token.access_token) {
				console.warn('No hay token disponible para cargar alertas');
				this.setState({
					alerts: [],
					filtered_alerts: [],
					loading: false,
				});
				return;
			}

			const response = await timesService.alertsToday();

			// console.log(response);

			if (response && response.ok) {
				this.setState({
					alerts: response,
					filtered_alerts: response,
					loading: false,
				});
			} else {
				// Si la respuesta no es ok, inicializar con arrays vacíos
				this.setState({
					alerts: [],
					filtered_alerts: [],
					loading: false,
				});
			}
		} catch (error) {
			// Manejar errores de red o de petición
			console.error('Error al cargar alertas:', error);
			this.setState({
				alerts: [],
				filtered_alerts: [],
				loading: false,
			});
		}
	}

	async getGroups() {
		await this.props.getAllGroups();
	}

	handleChangeSearch = (event) => {
		const { alerts } = this.state;
		const value = event.target.value;

		this.setState({
			filtered_alerts:
				value < 0
					? alerts
					: alerts.filter((a) => a.group_id === parseInt(value)),
		});
	};

	getAlertRows = () =>
		this.state.filtered_alerts.map((alert, i) => {
			return (
				<tr key={i}>
					<td>
						<span className="employee-name">
							<Link to={`/times/${alert.employee_id}/employee`}>
								<Avatar
									userId={alert.employee_id}
									className="avatar-xs"
									alt={alert.employee_name}
								/>
								{alert.employee_name}
							</Link>
						</span>
					</td>
					<td>{alert.plan_time ? convertFromUTC(alert.plan_time) : "-"}</td>
					<td>
						{alert.time_registration_time
							? convertFromUTC(alert.time_registration_time)
							: "-"}
					</td>
					<td>{TIME_ALERTS[alert.type]}</td>
				</tr>
			);
		});

	getCardTop = () => {
		const { groups, t } = this.props;
		const { alerts } = this.state;

		const optionList =
			groups?.length > 0 &&
			groups?.map((item, i) => {
				return (
					<option key={i} value={item.id}>
						{item.name}
					</option>
				);
			}, this);

		return (
			<div className="card-heading">
				<h2>{t("widgets.timeAlerts.title")}</h2>
				{alerts.length > 0 && (
					<div className="heading-actions">
						<FormGroup className="form-group form-search" controlId="filterGroupId">
							<FormControl
								type="text"
								placeholder={t("common.search")}
								value={this.state.filterGroupId}
								onChange={this.handleChangeSearch}
								as="select"
							>
								<option value="-1">{t("widgets.timeAlerts.filterByGroup")}</option>
								{optionList}
							</FormControl>
						</FormGroup>
					</div>
				)}
			</div>
		);
	};

	getContent = () => {
		const { alerts, filtered_alerts } = this.state;
		const { t } = this.props;

		if (alerts?.length === 0 && filtered_alerts?.length === 0) {
			return (
				<div className="empty">
					<FiThumbsUp />
					<p>{t("widgets.timeAlerts.noAlerts")}</p>
				</div>
			);
		} else if (filtered_alerts.length > 0) {
			return (
				<table className="table dashboard-table table-alerts">
					<thead>
						<tr>
							<th>{t("widgets.timeAlerts.employee")}</th>
							<th>{t("widgets.timeAlerts.scheduledTime")}</th>
							<th>{t("widgets.timeAlerts.actualTime")}</th>
							<th>{t("widgets.timeAlerts.type")}</th>
						</tr>
					</thead>
					<tbody>{this.getAlertRows()}</tbody>
				</table>
			);
		} else {
			return (
				<div className="empty">
					<p>{t("widgets.timeAlerts.noResultsForGroup")}</p>
				</div>
			);
		}
	};

	render() {
		return (
			<>
				<div className="card-top">{this.getCardTop()}</div>
				<div className="card-content">{this.getContent()}</div>
			</>
		);
	}
}

const mapStateToProps = (reducers) => {
	return {
		...reducers.timesReducer,
		...reducers.groupsReducer,
		user: reducers.authReducer.user,
	};
};

const mapDispatchToProps = (dispatch) => ({
	getAllGroups: () => dispatch(groupsActions.getAllGroups({ sort: "+name" })),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withTranslation()(Dashboard_TimeAlerts));
